(function() {

	var HomePage = function() {
		this.initAddToCart();
		C.clamp();
	};

	HomePage.prototype = {
		// Add To Cart Dialog
		initAddToCart: function() {
			$('form.product-add-to-cart').each(function(i, elem) {
				new C.AddToCart(elem);
			});
		}
	};

	C.HomePage = HomePage;

})();
